<template lang="pug">
.h-vertical-align-container(v-show='modalShow')
  .modal__overlay(@click='closeModal()')
  .modal__wrapper.modal__wrapper--marketingConsent
    .modal__marketingconsent
      h1 Add your watermarks in the app!
      .marketingConsent--container
        p The latest versions of Cinemagraph Pro and Cinemagraph Pro for iOS now allow you to add images to your cinemagraphs!
        download-trial-button(
          product='pro',
          classes='btn btn--blue btn--download',
          copy='Download',
        )
</template>

<script>
import EventBus from '../eventBus.js';
import downloadButton from './downloadTrialButton.vue';

export default {
  name: 'Watermark-modal',
  data() {
    return {
      modalShow: false,
    };
  },
  mounted() {
    const self = this;
    EventBus.$on('openWatermarkEmbed', function () {
      self.modalShow = true;
    });
    EventBus.$on('closeWatermarkEmbed', function () {
      self.modalShow = false;
    });
  },
  methods: {
    closeModal() {
      this.modalShow = false;
    },
  },
  components: {
    'download-trial-button': downloadButton,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/watermarkWarning.vue